"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidMask = void 0;
const js_brasil_1 = require("js-brasil");
function isValidMask(value) {
    if (typeof value !== 'string')
        return false;
    return js_brasil_1.validateBr.email(value);
}
exports.isValidMask = isValidMask;
//# sourceMappingURL=email.js.map